/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAllInvestmentEntities} from '../api'

 export const useQueryGetAllInvestmentEntities = createReactQueryHook('getAllInvestmentEntities', getAllInvestmentEntities)
